module.exports = __webpack_public_path__ + "img/map1.d5edf7ea.png";